import React, { useEffect, useState } from 'react';
import AssessmentEvents from 'events/AssessmentEvents';

import { withStyles } from '@mui/styles';

import SwitchBrandWithLabel from 'libraries/SwitchBrandWithLabel';
import styles from '../../styles';

const TextPastingSwitch = ({ question, changeQuestionSettings, audition }) => {
    const [disabledPasting, setDisabledPasting] = useState(disableTextPasting);
    const { uuid, name } = audition;
    const { id, answerType, questionSettings: { disableTextPasting }, sort } = question;

    useEffect(() => {
        setDisabledPasting(disableTextPasting);
    }, [id, answerType]);

    const handleChangeRequiredQuestion = () => {
        const newValue = !disabledPasting;
        setDisabledPasting(newValue);
        changeQuestionSettings({ disableTextPasting: newValue }, { skipCheck: true });

        AssessmentEvents.QUESTION_BLOCK_PASTE({
            enabled: newValue,
            ttUUID: uuid,
            ttName: name,
            questionNumber: sort
        });
    };

    return (
        <>
            <SwitchBrandWithLabel
                label="Disable text pasting"
                checked={Boolean(disabledPasting)}
                className="u-mrg--bx0"
                onChange={handleChangeRequiredQuestion}
            />
        </>
    );
};

export default withStyles(styles)(TextPastingSwitch);
